/* global ajaxObject */

$(function () {
  var canSubmit = true;

  $('#newsletter-form').on('submit', function (event) {
    event.preventDefault();
    if (!canSubmit) return;

    canSubmit = false;
    var $form = $(this);
    var email = $form.find('input[name="email"]').val();
    var challenge = $form.find('input[name="challenge"]').val();
    var nonce = $form.find('input[name="nonce"]').val();

    $.ajax({
      url: ajaxObject.ajaxurl,
      method: 'POST',
      data: {
        action: 'process_newsletter',
        email: email,
        challenge: challenge,
        nonce: nonce,
      },
      success: function (response) {
        $('#newsletter-response').html(response);
      },
      error: function () {
        $('#newsletter-response').html('Une erreur est survenue.');
      },
      complete: function () {
        setTimeout(function () {
          canSubmit = true;
        }, 3000);
      },
    });
  });
});
